import { gsap } from './gsap-config';

export default function bannerSvg() {
    const bannerAnim= gsap.timeline({  repeat: -1,  duration:1.5});
    const bannerAnim2= gsap.timeline({  repeat: -1, duration:1.5 });
    const bannerAnim3= gsap.timeline({  repeat: -1, duration:1.5 });
    const bannerAnim4= gsap.timeline({  repeat: -1, duration:1.5 });
    const bannerAnim5= gsap.timeline({  repeat: -1, duration:.5 });
    const bannerAnim6= gsap.timeline({  repeat: -1, duration:1 });
    const bannerAnim7= gsap.timeline({  repeat: -1, duration:1 });
    const bannerAnim8= gsap.timeline({  repeat: -1, duration:1 });
    const bannerAnim9= gsap.timeline({  repeat: -1, duration:3 });

    bannerAnim.to(".banner-M-point1",{ duration:.75, y: 14, x: 4,  }, );
    bannerAnim.to(".banner-M-point1",{ duration:.75, y: 26, x:-20, });
    bannerAnim.to(".banner-M-point1",{ duration:.75, y: 17, x: -40, },);
    bannerAnim.to(".banner-M-point1",{ duration:.75, y: 0, x: 0},);

    bannerAnim2.to(".banner-M-point2", { duration:.75, x: -15, y: 6, }, );
    bannerAnim2.to(".banner-M-point2", { duration:.75, x: 25, y: 0, }, );
    bannerAnim2.to(".banner-M-point2", { duration:.75, x: 7, y: 10, }, );
    bannerAnim2.to(".banner-M-point2", { duration:.75, y: 0, x: 0, },);

    bannerAnim3.to(".banner-M-point3", { duration:.75, y: 17, x: 0, },);
    bannerAnim3.to(".banner-M-point3", { duration:.75, y: 5, x: -5, },);
    bannerAnim3.to(".banner-M-point3", { duration:.75, y: 8, x: -22, },);
    bannerAnim3.to(".banner-M-point3", { duration:.75, y: 0, x: 0, }, );

    gsap.timeline({ yoyo: true, repeat: -1, }).to(".banner-M-envp",{duration:1, y:5 },);

    bannerAnim4.to(".banner-M-brasd",{ duration:1, rotate:5, transformOrigin:"right center" },);
    bannerAnim4.to(".banner-M-brasd",{ duration:.7, rotate:-6, transformOrigin:"right center" },);
    bannerAnim4.to(".banner-M-brasd",{ duration:.6, rotate:-3, transformOrigin:"right center" },);
    bannerAnim4.to(".banner-M-brasd",{ duration:.5, rotate:5, transformOrigin:"right center" },);
    bannerAnim4.to(".banner-M-brasd",{ duration:1, rotate:0, transformOrigin:"right center" },);

    gsap.timeline({ yoyo: true, repeat: -1, duration:.5 }).to(".banner-M-ww",{ duration:1, x:0, y:1, ease: "power4"},);
    gsap.timeline({ yoyo: true, repeat: -1, duration:.5 }).to(".banner-M-gg",{ duration:1, x:24, y:2, ease: "power4" },);
    gsap.timeline({ yoyo: true, repeat: -1, duration:.5 }).to(".banner-M-rr",{ duration:1, x:11, y:7, ease: "power4" },);
    gsap.timeline({ yoyo: true, repeat: -1, duration:.5 }).to(".banner-M-yy",{ duration:1, x:35, y:5, ease: "power4" },);

    gsap.timeline({ yoyo: true, repeat: -1, duration:1 }).to(".banner-M-dot_white",{duration:2, x:23, y:-11, ease: "power4" },);

    gsap.timeline({ yoyo: true, repeat: -1, duration:0.1 }).to(".banner-M-tab1",{ duration:5, x:0, y:3, },);
    gsap.timeline({ yoyo: true, repeat: -1, duration:0.1 }).to(".banner-M-tab2",{ duration:3, x:0, y:5, },);
    gsap.timeline({ yoyo: true, repeat: -1, duration:0.1 }).to(".banner-M-tab3",{ duration:4, x:0, y:2, },);
    gsap.timeline({ yoyo: true, repeat: -1, duration:0.1 }).to(".banner-M-paysage",{  duration:3, x:0, y:7, },);

    gsap.timeline({ yoyo: true, repeat: -1, duration:.5 }).to(".banner-M-br",{ duration:1,x:27, y:-16, ease: "power4"},);
    gsap.timeline({ yoyo: true, repeat: -1, duration:.5 }).to(".banner-M-yr",{ duration:1, x:18, y:-10.5, ease: "power4" },);
    gsap.timeline({ yoyo: true, repeat: -1, duration:.5 }).fromTo(".banner-M-rr2",{x:-.5, y:0},{ duration:1, x:9, y:-5, ease: "power4" },);

    gsap.timeline({ yoyo: true, repeat: -1,}).to(".banner-M-w2",{ duration:1, y:1, },);
    gsap.timeline({ yoyo: true, repeat: -1,}).to(".banner-M-g2",{ duration:1, y:2, },);
    gsap.timeline({ yoyo: true, repeat: -1,}).to(".banner-M-r2",{ duration:1, y:3, },);
    gsap.timeline({ yoyo: true, repeat: -1,}).to(".banner-M-b2",{ duration:1, y:1, },);

    gsap.timeline({ yoyo: true, repeat: -1,}).to(".banner-M-coeur",{duration:1.3, transformOrigin:"center center", scale:.65, ease: "power3"},);

    gsap.timeline({ yoyo: true, repeat: -1,duration:.5}).to(".banner-M-w",{duration:.5, transformOrigin:"center center", scale:.65, ease: "power2"},);
    gsap.timeline({ yoyo: true, repeat: -1,duration:.5}).to(".banner-M-r",{duration:1, transformOrigin:"center center", scale:.65, ease: "power2"},);
    gsap.timeline({ yoyo: true, repeat: -1,duration:.5}).to(".banner-M-g",{duration:1.5, transformOrigin:"center center", scale:.65, ease: "power2"},);

    gsap.timeline({ yoyo: true, repeat: -1,duration:.5}).to(".banner-check1",{duration:.5, transformOrigin:"center center", scale:.7, ease: "power4"},);
    gsap.timeline({ yoyo: true, repeat: -1,duration:1}).to(".banner-check2",{duration:.5, transformOrigin:"center center", scale:.7, ease: "power4"},);

    gsap.timeline({ yoyo: true, repeat: -1,duration:1}).to(".banner-M-pizza",{duration:.7, transformOrigin:"left center", rotate:7},);

    gsap.timeline({ yoyo: true, repeat: -1,duration:.5}).to(".banner-M-bras",{duration:1, transformOrigin:"left top", rotate: -7, },);
    gsap.timeline({ yoyo: true, repeat: -1,duration:1}).to(".banner-M-tete",{duration:.5, transformOrigin:"center bottom", rotate:5,},);

    gsap.timeline({ yoyo: true, repeat: -1,}).fromTo(".banner-M-avion",{transformOrigin:"center center", scale:1, ease: "power3"}, {duration:2, x:-17, y:13, scale:.9, },);

    bannerAnim5.to(".banner-M-dotpic",{ duration:1, x:5, y:5, ease: "power2"},);
    bannerAnim5.to(".banner-M-dotpic",{ duration:1, x:10, y:0, ease: "power2" },);
    bannerAnim5.to(".banner-M-dotpic",{ duration:1, x:9, y:-9, ease: "power2" },);
    bannerAnim5.to(".banner-M-dotpic",{ duration:1, x:0, y:0, ease: "power2" },);

    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:-26, y:12, transformOrigin:"bottom left", rotate:3},);
    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:-21, y:14, transformOrigin:"bottom left", rotate:-3},);
    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:-20, y:11, transformOrigin:"bottom left", rotate:3},);
    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:-17, y:7, transformOrigin:"bottom left", rotate:-3},);
    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:-12, y:9,transformOrigin:"bottom left", rotate:3},);
    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:-9, y:2, transformOrigin:"bottom left", rotate:-3},);
    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:-4, y:4,transformOrigin:"bottom left", rotate:3},);
    bannerAnim6.to(".banner-M-crayon",{duration:.3, x:0, y:0,transformOrigin:"bottom left", rotate:0},);

    bannerAnim7.to(".banner-megaphone",{ duration:1, transformOrigin:"bottom right", rotate:7},);
    bannerAnim7.to(".banner-megaphone",{ duration:1, transformOrigin:"bottom right", rotate:0},3);

    bannerAnim8.to(".banner-M-queue",{duration:.3, transformOrigin:"bottom left", rotate:15},);
    bannerAnim8.to(".banner-M-queue",{duration:.3, transformOrigin:"bottom left", rotate:-15},);
    bannerAnim8.to(".banner-M-queue",{duration:.3, transformOrigin:"bottom left", rotate:0},);

    bannerAnim9.fromTo(".banner-mega_blue",{transformOrigin:"center center", y:0, x:0, opacity: 0, scale:.9 },{duration:.5, transformOrigin:"center center",scale:1.3 ,y:-15, x:-20, opacity: 1, ease: "power2"},);
    bannerAnim9.to(".banner-mega_blue",{duration:.5, transformOrigin:"center center",scale:1.3 ,y:-15, x:-20, opacity: 0, ease: "power2"},);
}
